import i18n from "locales/i18n";
import {useState} from 'react';

export default function LocaleSwitcher(props){
  const [locale, setCurrentLocale] = useState(i18n.language ?? 'ko');

  const setLocale = (locale)=>{
    i18n.changeLanguage(locale);
    setCurrentLocale(locale);
  }

  return (
    <div {...props}>
      <span onClick={()=>setLocale('ko')} className={`${'ko'===locale ?'text-hover':'text-gray-400'}`}>한국어</span>
      <span className="ml-4 mr-4">|</span>
      <span onClick={()=>setLocale('en')} className={`${'en'===locale ?'text-hover':'text-gray-400'}`}>ENG</span>
    </div>
  );
}